import { getStorage } from '@picsart/growth-rc/services/browserStorage';
import { PREV_TAB_ID } from 'constants/homePage';

const addAnalyticsParamsToUrl = (
  url: string,
  params: { source: string; origin: string; fileUid?: string },
) => {
  const tabId = getStorage(PREV_TAB_ID, false);

  const [baseUrl, searchParams] = url.split('?');
  const newSearchParams = new URLSearchParams(searchParams);

  Object.keys(params).forEach(param => {
    newSearchParams.append(param, encodeURIComponent(params[param as keyof typeof params]));
  });

  if (tabId) {
    newSearchParams.append('source_id', encodeURIComponent(tabId));
  }

  return `${baseUrl}?${newSearchParams.toString()}`;
};

export default addAnalyticsParamsToUrl;
